export enum CoinUnitEnum {
  THB = 'THB',
  COIN = 'COIN',
}
